import { catchError, map, Observable } from "rxjs";
import { urlServiceHospitalInfra } from "../../constants/hospital-infra.constants";
import { RestService } from "../communication-rest/communication-rest.service";
import { Injectable } from "@angular/core";
import { CatalogDto } from "../../models/generic/catalog.dto";
import { HttpErrorCodeService } from "../../shared/error/http-error-code";
import { ResponseDto } from "../../models/generic/response.dto";
import { FormOrgLangDto } from "../../models/configuration/forms/form-org-lan.dto";


@Injectable({
    providedIn: 'root'
})
export class CatUserLoginService {    

    constructor(protected restService: RestService){
    }

    listOrganizationsByUser(username: string){        
        return this.restService.get<CatalogDto[]>(urlServiceHospitalInfra.catalogOrgs.concat(username));
    }
    listBranchesByUser(userId: string, orgId: string){
        return this.restService.get<CatalogDto[]>(urlServiceHospitalInfra.catalogBranches.concat(userId).concat('/').concat(orgId));
    }
    listProfilesByUser(userId: string, branchId: string){
        return this.restService.get<CatalogDto[]>(urlServiceHospitalInfra.catalogProfiles.concat(userId).concat('/').concat(branchId));
    }

    getUserProfilesAndWorkplaces(username : string){
        return this.restService.get<any>(urlServiceHospitalInfra.catalogUserInfo.replace('{username}', username))
            .pipe(                
                map(resp => {
                    const res = resp.response;         
                    let isDirect: boolean;
                    if(res.organizations.length === 0) { //No tiene organizaciones
                        isDirect = false;
                    } else if(res.organizations.length === 1) { //Tiene al menos una organizacion 
                        if (res.organizations[0].branchOffices.length === 0) { //No tiene sucursal
                            isDirect = false;
                        } else if (res.organizations[0].branchOffices.length === 1) {//Tiene al menos 1 sucursal
                            if (res.organizations[0].branchOffices[0].profiles.length === 0) {//No tiene perfiles
                                isDirect = false;
                            } else if (res.organizations[0].branchOffices[0].profiles.length === 1) {//Tiene al menos 1 perfil
                                isDirect = false;
                            } else {//Tiene más de un perfil
                                isDirect = true;
                            }
                        } else { //Tiene más de una sucursales
                            isDirect = true;
                        }
                    } else { //Tiene mas de una organizaciones
                        isDirect = true;
                    }
                    return {
                        direct: isDirect,
                        workplace : res.organizations
                    }
                }),
                catchError((error) => {
                    throw HttpErrorCodeService.getMessage(error);
                })
            );
    }
    getFormsByLanCveAndIdOrg(languageCve : string, orgId : number){
        return this.restService.get<ResponseDto>(urlServiceHospitalInfra.catalogUserForms.replace('{languageCve}', languageCve).replace('{organizationId}', orgId.toString()))
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, "", true);
                })
            )
    }

    getFormsByUrl(languageCve : string, branchId : number, url: string) : Observable<FormOrgLangDto[]>{
        let filter = { languageCve : languageCve, branchId : branchId, url: url };
        return this.restService.post<ResponseDto>(urlServiceHospitalInfra.formLabelTraduction, filter, true)
            .pipe(
                map(res => {
                    return this.restService.getResultResponse(res, "", true);
                })
            )
    }
}